import React from "react";
import styles from "./Button.module.css";

const Button = ({ text, style, onClick, disabled, rightIcon, textStyle }) => {
  return (
    <>
      <button disabled={disabled} style={style} onClick={onClick} className={styles.safe__Button}>
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: "center" }}>
          {text ? <text style={textStyle} className={styles.buttontext} >{text}</text> : ''}
          {rightIcon ? rightIcon : null}
        </div>
      </button>
    </>
  );
};

export default Button;
